/* API action types */
// Fetch all job applications
export const FETCH_JOB_APPLICATION_LIST = "FETCH_JOB_APPLICATION_LIST";
export const FETCH_JOB_APPLICATION_LIST_SUCCESS = "FETCH_JOB_APPLICATION_LIST_SUCCESS";
export const FETCH_JOB_APPLICATION_LIST_FAILURE = "FETCH_JOB_APPLICATION_LIST_FAILURE";

// CUSTOMVIEW - create job application custom view
export const CREATE_JOB_APP_CUSTOM_VIEW = "CREATE_JOB_APP_CUSTOM_VIEW";
export const CREATE_JOB_APP_CUSTOM_VIEW_SUCCESS = "CREATE_JOB_APP_CUSTOM_VIEW_SUCCESS";
export const CREATE_JOB_APP_CUSTOM_VIEW_FAILURE = "CREATE_JOB_APP_CUSTOM_VIEW_FAILURE";

// CUSTOMVIEW - fetch all job application custom view
export const FETCH_JOB_APP_CUSTOM_VIEW = "FETCH_JOB_APP_CUSTOM_VIEW";
export const FETCH_JOB_APP_CUSTOM_VIEW_SUCCESS = "FETCH_JOB_APP_CUSTOM_VIEW_SUCCESS";
export const FETCH_JOB_APP_CUSTOM_VIEW_FAILURE = "FETCH_JOB_APP_CUSTOM_VIEW_FAILURE";

// CUSTOMVIEW - fetch job application custom view by id
export const FETCH_JOB_APP_CUSTOM_VIEW_BY_ID = "FETCH_JOB_APP_CUSTOM_VIEW_BY_ID";
export const FETCH_JOB_APP_CUSTOM_VIEW_BY_ID_SUCCESS = "FETCH_JOB_APP_CUSTOM_VIEW_BY_ID_SUCCESS";
export const FETCH_JOB_APP_CUSTOM_VIEW_BY_ID_FAILURE = "FETCH_JOB_APP_CUSTOM_VIEW_BY_ID_FAILURE";

// CUSTOMVIEW - delete job application custom view by id
export const DELETE_JOB_APP_CUSTOM_VIEW_BY_ID = "DELETE_JOB_APP_CUSTOM_VIEW_BY_ID";
export const DELETE_JOB_APP_CUSTOM_VIEW_BY_ID_SUCCESS = "DELETE_JOB_APP_CUSTOM_VIEW_BY_ID_SUCCESS";
export const DELETE_JOB_APP_CUSTOM_VIEW_BY_ID_FAILURE = "DELETE_JOB_APP_CUSTOM_VIEW_BY_ID_FAILURE";

// CUSTOMVIEW - select job application custom view by id
export const SELECT_JOB_APP_CUSTOM_VIEW_BY_ID = "SELECT_JOB_APP_CUSTOM_VIEW_BY_ID";
export const SELECT_JOB_APP_CUSTOM_VIEW_BY_ID_SUCCESS = "SELECT_JOB_APP_CUSTOM_VIEW_BY_ID_SUCCESS";
export const SELECT_JOB_APP_CUSTOM_VIEW_BY_ID_FAILURE = "SELECT_JOB_APP_CUSTOM_VIEW_BY_ID_FAILURE";

// CUSTOMVIEW - unselect job application custom view
export const UNSELECT_JOB_APP_CUSTOM_VIEW = "UNSELECT_JOB_APP_CUSTOM_VIEW";
export const UNSELECT_JOB_APP_CUSTOM_VIEW_SUCCESS = "UNSELECT_JOB_APP_CUSTOM_VIEW_SUCCESS";
export const UNSELECT_JOB_APP_CUSTOM_VIEW_FAILURE = "UNSELECT_JOB_APP_CUSTOM_VIEW_FAILURE";

// CUSTOMVIEW - edit job application custom view by id
export const EDIT_JOB_APP_CUSTOM_VIEW_BY_ID = "EDIT_JOB_APP_CUSTOM_VIEW_BY_ID";
export const EDIT_JOB_APP_CUSTOM_VIEW_BY_ID_SUCCESS = "EDIT_JOB_APP_CUSTOM_VIEW_BY_ID_SUCCESS";
export const EDIT_JOB_APP_CUSTOM_VIEW_BY_ID_FAILURE = "EDIT_JOB_APP_CUSTOM_VIEW_BY_ID_FAILURE";

// Update job application status
export const UPDATE_JOB_APPLICATION_STATUS_BY_ID = "UPDATE_JOB_APPLICATION_BY_ID_STATUS";
export const UPDATE_JOB_APPLICATION_STATUS_BY_ID_SUCCESS = "UPDATE_JOB_APPLICATION_STATUS_BY_ID_SUCCESS";
export const UPDATE_JOB_APPLICATION_STATUS_BY_ID_FAILURE = "UPDATE_JOB_APPLICATION_STATUS_BY_ID_FAILURE";

// Reject job application candidate
export const REJECT_JOB_APPLICATION_BY_ID = "REJECT_JOB_APPLICATION_BY_ID";
export const REJECT_JOB_APPLICATION_BY_ID_SUCCESS = "REJECT_JOB_APPLICATION_BY_ID_SUCCESS";
export const REJECT_JOB_APPLICATION_BY_ID_FAILURE = "REJECT_JOB_APPLICATION_BY_ID_FAILURE";

// Fetch candidate id by email from candidate service
export const FETCH_CANDIDATE_ID_BY_EMAIL = "FETCH_CANDIDATE_ID_BY_EMAIL";
export const FETCH_CANDIDATE_ID_BY_EMAIL_SUCCESS = "FETCH_CANDIDATE_ID_BY_EMAIL_SUCCESS";
export const FETCH_CANDIDATE_ID_BY_EMAIL_FAILURE = "FETCH_CANDIDATE_ID_BY_EMAIL_FAILURE";


/* UI action types */
// Reset job application list
export const RESET_JOB_APPLICATION_LIST = "RESET_JOB_APPLICATION_LIST";

// Set, Delete, Reset job application default custom view
export const SET_JOB_APP_DEFAULT_CUSTOM_VIEW = "SET_JOB_DEFAULT_CUSTOM_VIEW";
export const DELETE_JOB_APP_DEFAULT_CUSTOM_VIEW = "DELETE_JOB_DEFAULT_CUSTOM_VIEW";
export const RESET_JOB_APP_CUSTOM_VIEW = "RESET_JOB_APP_CUSTOM_VIEW";

// Set loading state
export const SET_LOADING = "SET_LOADING";

// Set approveAction state
export const SET_APPROVE_ACTION = "SET_APPROVE_ACTION";

// Set approveSuccess state
export const SET_APPROVE_SUCCESS = "SET_APPROVE_SUCCESS";

// Set candidate id state
export const SET_CANDIDATE_ID = "SET_CANDIDATE_ID";